import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoadingScreen from "./components/LoadingScreen";
import NotFound from "./routes/error/404";
import ScanError from "./routes/error/ScanError";
import FaceScan from "./routes/FaceScan";
import FingerScan from "./routes/FingerScan";
import Tutorial from "./routes/Tutorial";
import LabPackages from "./routes/LabPackages";
import ABHAID from "./routes/ABHAID";

let router = createBrowserRouter([
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "scan/face",
    element: <FaceScan />,
    errorElement: <ScanError />,
  },
  {
    path: "scan/finger",
    element: <FingerScan />,
    errorElement: <ScanError />,
  },
  {
    path: "lab-packages",
    element: <LabPackages />,
  },
  {
    path: "tutorial",
    element: <Tutorial />,
  },
  {
    path: "abha-id",
    element: <ABHAID />,
  },
]);

const App = () => {
  return <RouterProvider router={router} fallbackElement={<LoadingScreen />} />;
};

export default App;
